import React, { useState, useEffect } from "react"
import Image from "gatsby-image"
import parse from "html-react-parser"
import { Link } from "gatsby"
import * as JsSearch from "js-search"
import * as styles from "./search-container.module.css"
import Arrow from "./arrow"
import { Container, Row, Col } from "react-bootstrap"
import HoverCard from "./hoverCard"
import { useMediaQuery } from "react-responsive"

function Search({ workerList, noSearchBar }) {
  const [search, setSearch] = useState([])
  const [searchResults, setSearchResults] = useState([])
  const [isLoading, setIsLoading] = useState(true)
  // const [isError, setIsError] = useState(false)
  const [searchQuery, setSearchQuery] = useState("")
  /**
   * React lifecycle method to fetch the data
   */
  useEffect(() => {
    rebuildIndex()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])
  const isMobile = useMediaQuery({
    query: "(max-width: 42rem)",
  })
  const isTablet = useMediaQuery({
    query: "(max-width: 64rem)",
  })

  /**
   * rebuilds the overall index based on the options
   */
  const rebuildIndex = () => {
    const dataToSearch = new JsSearch.Search("title")
    /**
     *  defines a indexing strategy for the data
     * more about it in here https://github.com/bvaughn/js-search#configuring-the-index-strategy
     */
    dataToSearch.indexStrategy = new JsSearch.PrefixIndexStrategy()
    /**
     * defines the sanitizer for the search
     * to prevent some of the words from being excluded
     *
     */
    dataToSearch.sanitizer = new JsSearch.LowerCaseSanitizer()
    /**
     * defines the search index
     * read more in here https://github.com/bvaughn/js-search#configuring-the-search-index
     */
    dataToSearch.searchIndex = new JsSearch.TfIdfSearchIndex("title")
    dataToSearch.addIndex("title") // sets the index attribute for the data
    dataToSearch.addIndex(["workerData", "job"]) // sets the index attribute for the data
    dataToSearch.addIndex(["workerData", "city"]) // sets the index attribute for the data
    dataToSearch.addDocuments(workerList) // adds the data to be searched
    setSearch(dataToSearch)
    window && window.fullpage_api && window.fullpage_api.reBuild()
    setIsLoading(false)
  }
  /**
   * handles the input change and perform a search with js-search
   * in which the results will be added to the state
   */
  const searchData = e => {
    const queryResult = search.search(e.target.value)
    setSearchQuery(e.target.value)
    setSearchResults(queryResult)
  }
  const handleSubmit = e => {
    e.preventDefault()
  }

  const noResults = searchQuery !== "" && searchResults.length === 0
  const queryResults =
    searchQuery === "" || noResults ? workerList : searchResults
  if (isLoading) {
    return null
  }
  return (
    <Container>
      <div>
        <form onSubmit={handleSubmit}>
          <Container
            fluid
            style={{
              textAlign: "center",
              display: "flex",
              justifyContent: "center",
            }}
          >
            {noSearchBar ? null : <Row noGutters className={styles.searchRow}>
              <Col xs="9" sm="6" lg="9">
                <input
                  id="Search"
                  value={searchQuery}
                  onChange={searchData}
                  placeholder={isTablet ? "Search Name" : "Search by Name, Profession, or City"}
                  className={styles.searchBar}
                />
              </Col>
              <Col xs="3" sm="6" lg="3">
                {isMobile ? <Arrow direction="right" width="20px" black /> : <Arrow direction="right" width="40px" black />}
              </Col>
            </Row>}
          </Container>
        </form>
        {noResults ? (
          <Container>
            <p style={{ color: "black", textAlign: "center" }}>
              No Search Results.
            </p>
          </Container>
        ) : null}
        <Container
          style={{
            display: "flex",
            flexWrap: "wrap",
            justifyContent: "space-around",
            margin: "auto",
          }}
        >
          <Row style={{ width: "100%" }}>
            {queryResults.map(worker => {
              const title = worker.title
              const city = worker.workerData.city
              const featuredImage = {
                fluid:
                  worker.featuredImage?.node?.localFile?.childImageSharp?.fluid,
                alt: worker.featuredImage?.node?.alt || ``,
              }
              return (
                <Col
                  key={worker.uri}
                  style={{ textAlign: "center", margin: "0 auto" }}
                  xs={6}
                  lg={4}
                >
                  <div
                    className={styles.workerList}
                    itemScope
                    itemType="http://schema.org/Article"
                  >
                    <HoverCard>
                      {noSearchBar ?
                        <div>
                          {featuredImage?.fluid && (
                            <Image
                              fluid={{ ...featuredImage.fluid, aspectRatio: 1 }}
                              alt={featuredImage.alt}
                              style={{
                                margin: "auto",
                                width: "100%",
                                textAlign: "center",
                              }}
                            />
                          )}
                          <p>
                            <span
                              itemProp="headline"
                              style={{
                                color: "black",
                                lineHeight: .5,
                              }}>
                              {parse(title)}
                            </span>
                          <br></br>
                            <span
                              itemProp="headline"
                              style={{
                                color: "black",
                                lineHeight: .5,
                                fontStyle: "italic",
                              }}>
                              {parse(city)}
                            </span>
                          </p>
                        </div>
                        : <Link to={worker.uri} itemProp="url">
                          {featuredImage?.fluid && (
                            <Image
                              fluid={{ ...featuredImage.fluid, aspectRatio: 1 }}
                              alt={featuredImage.alt}
                              style={{
                                margin: "auto",
                                width: "100%",
                                textAlign: "center",
                              }}
                            />
                          )}
                          <p>
                            <span
                              itemProp="headline"
                              style={{
                                color: "black",
                                lineHeight: .5,
                              }}>
                              {parse(title)}
                            </span>
                          </p>
                        </Link>
                      }


                    </HoverCard>
                  </div>
                </Col>
              )
            })}
          </Row>
        </Container>
      </div>
    </Container>
  )
}
export default Search
